<template>
  <div class="product-input-wrap">
    <vs-row class="input-row">
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        انتخاب دسته بندی
        <vs-select
          placeholder="انتخاب دسته بندی"
          v-model="category"
          width="100%"
        >
          <vs-select-item
            v-for="(category, index) of categories"
            :text="`${index + 1} - ${category.title}`"
            :key="category.id"
            :value="category"
          />
        </vs-select>
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        انتخاب زیردسته
        <vs-select
          placeholder="انتخاب زیردسته"
          v-model="subCategory"
          width="100%"
        >
          <vs-select-item
            v-for="(item, index) of category ? category.subCategories : []"
            :value="item"
            :text="`${index + 1} - ${item.title}`"
            :key="item.id"
          />
        </vs-select>
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        ترتیب نمایش
        <vs-input
          placeholder="ترتیب نمایش"
          v-model="productClone.level"
          :disabled="createMode"
          class="w-100"
        />
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        نام محصول
        <vs-input
          placeholder="نام محصول"
          v-model="productClone.title"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        قیمت (ریال)
        <vs-input
          placeholder="قیمت (ریال)"
          v-model="productClone.price"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        نام انگلیسی محصول
        <vs-input
          placeholder="نام انگلیسی محصول"
          v-model="productClone.english_title"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        درصد تخفیف
        <vs-input
          placeholder="درصد تخفیف"
          v-model="productClone.discount"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col
        class="input-column"
        vs-justify="center"
        vs-align="center"
        :vs-w="12"
      >
        توضیحات محصول
        <vs-textarea
          placeholder="توضیحات محصول را اینجا بنویسید..."
          v-model="productClone.details.description"
          class="mb-0 w-full w-100 mt-1"
        />
      </vs-col>
      <vs-col class="input-column mt-2" vs-w="6">
        <vs-checkbox
          v-model="productClone.available"
          :value="productClone.available"
          >موجودیت محصول</vs-checkbox
        >
      </vs-col>
      <vs-col class="input-column mt-2" vs-w="6">
        <vs-checkbox
          v-model="productClone.featured"
          :value="productClone.featured"
          >نمایش ویژه
        </vs-checkbox>
      </vs-col>
      <vs-col class="input-column my-3" vs-w="12">
        <vs-divider class="my-0"></vs-divider>
      </vs-col>
      <vs-col vs-w="12" class="mt-2 mb-0">
        <attachments
          ref="thumbnailAttachments"
          :data="productClone.thumbnail ? [productClone.thumbnail] : []"
          :aspectRatio="1"
          accept="image/*"
          :multiple="false"
          title="انتخاب تصویر پیشفرض:"
          subtitle="این بخش به عنوان تصویر پیش فرض روی محصولات قرار داده میشود."
          :urlForDelete="`items/${productClone.id}/`"
        />
      </vs-col>
      <vs-col vs-w="12" class="mt-2 mb-0">
        <attachments
          ref="albumAttachments"
          :data="productClone.album"
          :aspectRatio="1"
          accept="image/*,.heic"
          title="انتخاب آلبوم تصاویر:"
          subtitle="این بخش به عنوان آلبومی از تصاویر محصول در صفحه جزئیات محصول نمایش داده میشود."
          :urlForDelete="`items/${productClone.id}/`"
        />
      </vs-col>
      <vs-col vs-w="12" class="footer-col">
        <div class="footer">
          <div class="footer-actions">
            <loading-button
              containerClassName="footer-submit-wrap w-full flex-grow max-w-full flex-1  flex-shrink-0"
              className="w-full max-w-full"
              :title="(createMode ? 'ایجاد' : 'ویرایش') + ' محصول'"
              :loading="loading"
              :progress="progress"
              @confirm="sendRequest"
              @cancelUpload="cancelUpload"
            />
            <vs-button
              v-if="!createMode"
              @click="remove()"
              class="remove-btn w-full flex-1 px-0"
              color="danger"
              type="border"
              size="small"
            >
              <img
                style="width: 14px; margin-bottom: -4px; margin-left: 4px"
                src="../../assets/icons/trash.svg"
              />
              حذف محصول
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import productApiService from "./../../services/api/ProductApiService";
  import Attachments from "../../views/tickets/form/Attachments.vue";
  import LoadingButton from "../loading-button/LoadingButton.vue";

  export default {
    components: { Attachments, LoadingButton },
    name: "Input",
    data() {
      const productClone = {
        ...this.value,
        price: this.value.price.toString().numberFormat(),
        available: +this.value.available,
        featured: +this.value.featured,
      };
      if (!productClone.discount) productClone.discount = "";
      if (!productClone.details || !productClone.details.description)
        productClone.details = { description: "" };

      return {
        productClone,
        category: this.activeCategory,
        subCategory: this.activeSubCategory,
        arrangeProducts: null,
        Blob: window.Blob,
        loading: false,
        progress: 0,
        abortController: null,
      };
    },
    mounted() {
      this.checkLevel();
    },
    watch: {
      category() {
        this.arrangeProducts = null;
        this.subCategory = null;
      },
      "productClone.price"(newValue) {
        this.productClone.price = newValue
          .toString()
          .splitNumberFormat()
          .numberFormat();
      },
      subCategory(newSubCategory) {
        this.checkLevel(newSubCategory);
      },
    },
    computed: mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    methods: {
      checkLevel(subCategory) {
        if (this.createMode) {
          if (subCategory) {
            this.productClone.level = subCategory.items
              ? (+subCategory.items[subCategory.items.length - 1]?.level || 0) +
                1
              : 1;
          } else {
            this.productClone.level = this.category.items[
              this.category.items.length - 1
            ]
              ? (+this.category.items[this.category.items.length - 1]?.level ||
                  0) + 1
              : 1;
          }
        }
      },
      sendRequest() {
        this.abortController = new AbortController();
        this.productClone = {
          ...this.productClone,
          album: this.$refs.albumAttachments.getData(),
          thumbnail: this.$refs.thumbnailAttachments.getData(),
        };
        const product = {
          ...this.productClone,
          category: this.category,
          subCategory: this.subCategory,
        };
        if (!product.title || product.level === "" || !product.category) {
          this.$vs.notify({
            text: "لطفا تمامی فیلد ها را وارد کنید",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }
        if (this.category.subCategories?.length > 0 && !product.subCategory) {
          this.$vs.notify({
            text: "لطفا زیردسته مورد نظر را انتخاب کنید",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }
        this.loading = true;
        productApiService
          .createOrEditProduct(
            this.currentProvider.id,
            product.id,
            product,
            this.updateProgress,
            this.abortController
          )
          .then((result) => {
            this.$emit("close");
            this.$emit(
              this.createMode ? "productAdded" : "productUpdated",
              result.resource,
              product.category,
              product.subCategory
            );
            this.$vs.notify({
              text: "عملیات با موفقیت انجام شد.",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            if (err.status == 0) return;

            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.progress = 0;
            this.loading = false;
          });
      },
      updateProgress(percent) {
        this.progress = +percent;
      },
      cancelUpload() {
        this.progress = 0;
        this.abortController.abort();
      },
      remove() {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "حذف محصول",
          text: `از حذف محصول "${this.productClone.title}" اطمینان دارید؟`,
          acceptText: "بلی",
          cancelText: "خیر",
          accept: () => {
            this.$emit("delete");
          },
        });
      },
    },
    props: {
      value: {
        type: Object,
      },
      categories: {
        type: Array,
        required: true,
      },
      createMode: {
        type: Boolean,
        default: false,
      },
      activeCategory: {
        type: Object,
        required: true,
      },
      activeSubCategory: {
        type: Object,
        required: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  .product-input-wrap {
    position: relative;
  }

  .input-row {
    margin: 0 -10px -14px;
    position: relative;

    .input-column {
      padding: 0 10px;
      margin-bottom: 10px;
    }

    .footer-col {
      padding: 0 10px;
      margin-top: 0.75rem;
      margin-bottom: 10px;
    }
  }

  span {
    font-size: 0.8rem;
    color: #000;
  }

  .footer {
    background-color: #fff;
    padding: 0 0;

    .footer-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.75rem;

      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    .footer-submit-wrap {
      padding: 0;
      margin: 0;
      width: 100%;
    }

    .remove-btn {
      height: 42px;
      font-size: 14px;
      max-width: 50%;

      @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
      }
    }
  }
</style>
